<template>
    <div>
      <div v-if="isSmallScreen"> 
        <!-- Small screen layout -->
        <AboutUsHomePageSmallScreen />
      </div>
      <div v-else>
        <AboutUsHomePageBigScreen />
      </div>
    </div>
  </template>
  
  <script>
  import AboutUsHomePageSmallScreen from './AboutUsHomePageSmallScreen.vue';
  import AboutUsHomePageBigScreen from './AboutUsHomePageBigScreen.vue';
  
  export default {
    components: {
        AboutUsHomePageSmallScreen,
        AboutUsHomePageBigScreen
    },
    computed: {
      isSmallScreen() {
        return window.innerWidth <= 1262;
      }
    },
    mounted() {
      if (this.isSmallScreen) {
        this.loadSmallScreenScripts();
      } else {
        this.loadLargeScreenScripts();
      }
    },
    methods: {
      loadSmallScreenScripts() {
        const script = document.createElement('script');
        
        script.async = true;
        document.head.appendChild(script);
      },
      loadLargeScreenScripts() {
        const script = document.createElement('script');
        
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }
  </script>
  